!(function () {
    "use strict";
    var t,
        e = {
            5660: function () {},
            7660: function (t, e, i) {
                var n = i(7367);
                const s = "is-selected",
                    a = "is-disabled",
                    r = "is-initialised",
                    o = "is-thumbnail-initialised",
                    l = "is-visible",
                    c = "is-hover",
                    d = "carousel-beginning",
                    u = "carousel-end",
                    h = "onVariantChange";
                class p extends CustomEvent {}
                class m {
                    constructor(t) {
                        let e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                        (this.container = t),
                            (this.updateHistory = e),
                            (this.variantSelector = t.querySelector('[name="id"]')),
                            (this.elementData = t.querySelector("[data-variant-selector-data]")),
                            this.loadData(JSON.parse(this.elementData.innerHTML)),
                            this.variantSelector?.addEventListener("change", this.onInputChanged);
                    }
                    loadData(t) {
                        (this.elementData.innerHTML = JSON.stringify(t)), (this.data = t);
                    }
                    getVariantId() {
                        return parseInt(this.variantSelector?.value);
                    }
                    getVariant() {
                        const t = this.getVariantId();
                        return this.data.variants.find((e) => e.id === t);
                    }
                    setVariantId(t) {
                        if (isNaN(t) || !isFinite(t)) return;
                        if (!this.data.variants.some((e) => e.id === t)) return;
                        if (!this.variantSelector) return;
                        const e = this.getVariant();
                        (this.variantSelector.value = t.toString()),
                        window.location.href.includes("products") &&
                        this.updateHistory &&
                        (t === (0, n.variantFirstAvailableOrDefault)({ variants: this.data.variants }).id ? (0, n.queryReplaceParam)("variant", null) : (0, n.queryReplaceParam)("variant", t.toString())),
                            this.onVariantSelected();
                        const i = this.getVariant(),
                            s = new p(h, { bubbles: !0, cancelable: !1, detail: { oldVariant: e, newVariant: i, variantSelector: this } });
                        this.variantSelector.dispatchEvent(s);
                    }
                    getOptionValues() {
                        const t = {};
                        return (
                            this.data.options.forEach((e) => (t[e] = [])),
                                this.data.variants.forEach((e) => {
                                    e.options.forEach((e, i) => {
                                        const n = this.data.options[i];
                                        -1 === t[n].indexOf(e) && t[n].push(e);
                                    });
                                }),
                                t
                        );
                    }
                    setVariantOption(t, e) {
                        this.getOptionValues();
                        const i = this.getVariant(),
                            n = [];
                        for (let s = 0; s < this.data.options.length; s++) {
                            let a;
                            (a = s === t ? e : i.options[s]), n.push(a);
                        }
                        const s = this.data.variants.find((t) => t.options.every((t, e) => e >= this.data.options.length || n[e] === t));
                        return s ? (this.setVariantId(s.id), s) : null;
                    }
                    onInputChanged = (t) => {
                        this.setVariantId(parseInt(this.variantSelector.value));
                    };
                    onVariantSelected() {}
                    dispose() {
                        this.variantSelector.removeEventListener("change", this.onInputChanged);
                    }
                }
                const b = "[data-swatch]",
                    g = "[data-swatch-object]",
                    v = "[data-swatch-dropdown]",
                    y = "data-swatch-position",
                    f = "data-value",
                    _ = "is-selected";
                class S extends m {
                    constructor(t, e) {
                        super(t, e),
                            (this.swatches = Array.from(t.querySelectorAll(b).values())),
                            this.container.querySelectorAll(g).forEach((t) => {
                                t.addEventListener("click", this.onSwatchClick);
                            }),
                            this.container.querySelectorAll(v).forEach((t) => {
                                t.addEventListener("change", this.onDropdownChange);
                            }),
                            this.onVariantSelected();
                    }
                    onSwatchClick = (t) => {
                        const e = this.container.querySelectorAll("[data-swatch-title]"),
                            i = t.currentTarget,
                            n = i.closest(b);
                        let s = i.querySelector("[data-image]"),
                            a = this.container.closest(".o-product-thumbnail")?.querySelector(".o-product-thumbnail__image-container");
                        if (!n) return;
                        const r = parseInt(n.getAttribute(y) || ""),
                            o = i.getAttribute(f),
                            l = i.getAttribute("data-title");
                        l &&
                        e?.forEach((t) => {
                            t.innerText = l;
                        }),
                        !isNaN(r) && o && (s && a && (a.innerHTML = s.innerHTML), this.setVariantOption(r - 1, o));
                    };
                    onDropdownChange = (t) => {
                        const e = t.currentTarget,
                            i = e.closest(b);
                        if (!i) return;
                        const n = parseInt(i.getAttribute(y) || "");
                        isNaN(n) || this.setVariantOption(n - 1, e.value);
                    };
                    onVariantSelected() {
                        const t = this.getVariant();
                        if (
                            t &&
                            (this.swatches.forEach((e) => {
                                const i = parseInt(e.getAttribute(y) || "");
                                if (isNaN(i)) return;
                                const n = t.options[i - 1];
                                e.querySelectorAll(g).forEach((t) => {
                                    if (t.getAttribute(f) === n) {
                                        t.classList.add(_);
                                        let e = t.parentElement;
                                        e && e.classList.add(_);
                                    } else {
                                        t.classList.remove(_);
                                        let e = t.parentElement;
                                        e && e.classList.remove(_);
                                    }
                                });
                                e.querySelectorAll(v).forEach((t) => (t.value = n)),
                                    e.querySelectorAll("[data-swatch-value]").forEach((t) => {
                                        t.textContent = n;
                                    });
                            }),
                                this.container.classList.contains("o-product-thumbnail__footer"))
                        ) {
                            const e = new CustomEvent("updatePricing", { bubbles: !0, cancelable: !1, detail: { variant: t } });
                            this.container.dispatchEvent(e);
                        }
                    }
                    dispose() {
                        super.dispose(),
                            this.container.querySelectorAll(g).forEach((t) => {
                                t.removeEventListener("click", this.onSwatchClick);
                            }),
                            this.container.querySelectorAll(v).forEach((t) => {
                                t.removeEventListener("change", this.onDropdownChange);
                            });
                    }
                }
                const L = "is-disabled",
                    A = document.createElement("template");
                A.innerHTML = "\n  <slot></slot>\n";
                class q extends CustomEvent {}
                class E extends HTMLElement {
                    get value() {
                        return this.input ? this.input.valueAsNumber : this.fallbackValue;
                    }
                    set value(t) {
                        null !== this.max && (t = Math.min(this.max, t)), null !== this.min && (t = Math.max(this.min, t)), this.input && (this.input.valueAsNumber = t), (this.fallbackValue = t);
                    }
                    get min() {
                        const t = this.input ? this.input.min : this.fallbackMin;
                        if (null === t) return null;
                        if ("string" == typeof t) {
                            const e = parseInt(t);
                            if (!t.replace(/\s/g, "").length) return null;
                            if (isNaN(e)) return null;
                        }
                        return t;
                    }
                    set min(t) {
                        null === t ? (this.input && (this.input.min = ""), (this.fallbackMin = null)) : (this.input && (this.input.min = t.toString()), (this.fallbackMin = this.fallbackMin));
                    }
                    get max() {
                        const t = this.input ? this.input.max : this.fallbackMax;
                        if (null === t) return null;
                        if ("string" == typeof t) {
                            const e = parseInt(t);
                            if (!t.replace(/\s/g, "").length) return null;
                            if (isNaN(e)) return null;
                        }
                        return t;
                    }
                    set max(t) {
                        null === t ? (this.input && (this.input.max = ""), (this.fallbackMax = null)) : (this.input && (this.input.max = t.toString()), (this.fallbackMax = this.fallbackMin));
                    }
                    get disabled() {
                        return this.hasAttribute("disabled");
                    }
                    set disabled(t) {
                        t ? this.setAttribute("disabled", "disabled") : this.removeAttribute("disabled"), this.updateDisabled();
                    }
                    input = null;
                    btnMinus = null;
                    btnPlus = null;
                    line = null;
                    fallbackValue = 0;
                    fallbackMin = null;
                    fallbackMax = null;
                    constructor() {
                        super();
                        this.attachShadow({ mode: "open" }).appendChild(A.content.cloneNode(!0)),
                            (this.btnMinus = this.querySelector(".is-minus")),
                            (this.btnPlus = this.querySelector(".is-plus")),
                            (this.input = this.querySelector('input[type="number"]')),
                            this.classList.add("o-quantity-selector"),
                            (this.line = this.getAttribute("line")),
                            this.btnMinus?.addEventListener("click", this.onMinusClick),
                            this.btnPlus?.addEventListener("click", this.onPlusClick),
                            this.input?.addEventListener("change", this.onInputChanged),
                            this.updateDisabled();
                    }
                    onPlusClick = (t) => {
                        t.preventDefault(), (this.value += 1), this.onQuantityChanged();
                    };
                    onMinusClick = (t) => {
                        t.preventDefault(), (this.value -= 1), this.onQuantityChanged();
                    };
                    onInputChanged = (t) => {
                        (this.value = this.input?.valueAsNumber || this.value), this.onQuantityChanged();
                    };
                    onQuantityChanged() {
                        if (this.line)
                            try {
                                (0, n.cartChange)({ quantity: this.value, id: this.line });
                            } catch (t) {
                                console.warn(t);
                            }
                        const t = new q("onQtyChange", { bubbles: !0, cancelable: !1, detail: { qtySelector: this, newValue: this.value } });
                        this.dispatchEvent(t);
                    }
                    updateDisabled() {
                        [this.btnMinus, this.btnPlus, this.input].forEach((t) => {
                            var e;
                            this.disabled
                                ? (e = t) && ((e.disabled = !0), e.classList.add("is-disabled"))
                                : ((t) => {
                                    t && ((t.disabled = !1), t.classList.remove("is-disabled"));
                                })(t);
                        }),
                            this.disabled ? this.classList.add("is-disabled") : this.classList.remove("is-disabled");
                    }
                }
                customElements.get("quantity-selector") || customElements.define("quantity-selector", E);
                const w = "[data-label-element]",
                    M = document.querySelector("[data-sticky-form] .o-sticky-atc__add-btn"),
                    P = document.querySelector("[data-sticky-form] .o-sticky-atc__add-btn [data-label-element]");
                class T {
                    btnAdd = null;
                    btnAddMobile = null;
                    btnAddDesktop = null;
                    qtySelector = null;
                    form = null;
                    swatches = null;
                    rechargeSubscriptionOptionsElement = null;
                    rechargeWidget = null;
                    stickyPrice = null;
                    money = null;
                    compare = null;
                    parentCarousel = null;
                    parentCarouselTiles = null;
                    adding = !1;
                    ogPrice = 0;
                    customRetailPercentage = 0;
                    customRetailWording = null;
                    constructor(t) {
                        (this.container = t), this.queryChildren(t), this.attachEvents();
                    }
                    queryChildren(t) {
                        (this.btnAdd = t.querySelector("[data-product-form-add]")),
                            (this.btnAddDesktop = this.btnAdd ? this.btnAdd.querySelector(".is-desktop") : null),
                            (this.btnAddMobile = this.btnAdd ? this.btnAdd.querySelector(".is-mobile") : null),
                            (this.qtySelector = t.querySelector("[data-product-form-qty]")),
                            (this.money = t.querySelectorAll("[data-product-money]")),
                            (this.compare = t.querySelectorAll("[data-product-compare-money]")),
                            (this.rechargeSubscriptionOptionsElement = t.querySelector("[data-product-recharge-selling-plans]")),
                            (this.stickyPrice = document.querySelector("[data-sticky-form]")),
                            (this.parentCarousel = document.querySelector("[data-product-gallery-carousel]")),
                            (this.parentCarouselTiles = document.querySelectorAll(".c-product-gallery__media-container")),
                            setTimeout(() => {
                                this.rechargeWidget = document.querySelector(".rc-widget");
                            }, 2e3);
                    }
                    onVariantChange() {
                        if (!this.swatches) return;
                        const t = this.swatches.getVariant(),
                            e = t?.id,
                            i = Array.from(this.parentCarouselTiles).find((t) => t.getAttribute("data-variant") === e.toString());
                        if ((i?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" }), void 0 === t)) return;
                        const { inventory_management: s, inventory_policy: a, inventory_quantity: r, price: o, compare_at_price: l, selling_plan_allocations: c } = t,
                            d = (0, n.cartGetQuantityOfVariant)(t.id);
                        this.qtySelector && (this.qtySelector.max = "shopify" === s && "deny" === a ? (r || 0) - d : null),
                        this.container.classList.contains("c-product-main__form") && (this.updatePriceElements(o, l), this.updateAddToCart(t), this.updateRechargeVariant(c, o, l));
                    }
                    updateRechargeVariant(t, e, i) {
                        const s = this.container.querySelector(".recharge-subscription-widget"),
                            a = s?.querySelector(".subscription-radio"),
                            r = (s?.querySelector(".onetime-radio"), this.container.querySelector('[name="selling_plan"]')),
                            o = this.stickyPrice?.querySelector(".o-sticky-atc__price"),
                            l = this.container.querySelector(".c-product-form__price"),
                            c = this.container.querySelector(".rc-selling-plans-dropdown__select");
                        0 === t.length
                            ? (this.container?.classList.remove("has-selling-plan"),
                                setTimeout(() => {
                                    r && (r.value = ""), l && (l.innerHTML = `${(0, n.printMoney)(e)}`), o && (o.innerHTML = `${(0, n.printMoney)(e)}`);
                                }, 1e3))
                            : (a.click(), r && (r.value = `${c?.value}`), this.container?.classList.add("has-selling-plan"), this.updateStickyPriceBasedOnSubscription());
                    }
                    updatePriceElements(t, e) {
                        this.money && this.money.forEach((e) => (e.innerText = (0, n.printMoney)(t))),
                        this.compare && (e ? this.compare.forEach((t) => (t.innerText = (0, n.printMoney)(e))) : this.compare.forEach((t) => (t.innerText = "")));
                        const i = document.querySelector(".subscription-radio"),
                            s = document.querySelector(".onetime-radio"),
                            a = this.stickyPrice?.querySelector(".o-sticky-atc__price"),
                            r = this.container?.querySelector(".c-product-form__price");
                        i && i.classList.contains("rc-radio--active")
                            ? setTimeout(() => {
                                const e = i.querySelector(".rc-radio__label .rc-radio__price"),
                                    o = s.querySelector(".rc-radio__label");
                                let l = Number(t);
                                (l *= 0.9),
                                o && (o.innerText = `One-time purchase ${(0, n.printMoney)(Number(t))}`),
                                e && (e.innerText = `${(0, n.printMoney)(Number(l))}`),
                                a && this.updatePriceValue(a, (0, n.printMoney)(Number(l))),
                                r && this.updatePriceValue(r, (0, n.printMoney)(Number(l)));
                            }, 200)
                            : (a && this.updatePriceValue(a, (0, n.printMoney)(t)), r && this.updatePriceValue(r, (0, n.printMoney)(t)));
                    }
                    updateStickyPriceBasedOnSubscription() {
                        if (!this.rechargeWidget) return;
                        this.rechargeWidget.querySelectorAll('input[type="radio"]').forEach((t) => {
                            t.addEventListener("change", () => {
                                this.updateStickyPriceElement(t);
                            }),
                            t.checked && this.updateStickyPriceElement(t);
                        });
                    }
                    updateStickyPriceElement(t) {
                        const e = this.stickyPrice?.querySelector(".o-sticky-atc__price"),
                            i = this.container?.querySelector(".c-product-form__price");
                        if ("subscription" === t.value) {
                            document.querySelector("[data-product-main]")?.classList.remove("is-one-time");
                            const s = t.nextElementSibling?.querySelector(".rc-radio__label .rc-radio__price");
                            let a = s?.innerText;
                            t.nextElementSibling?.querySelector(".rc-radio__label .rc-radio__price .is-price") && (a = `${(0, n.printMoney)(Number(this.ogPrice))}`), this.updatePriceValue(e, a), this.updatePriceValue(i, a);
                        } else if ("onetime" === t.value) {
                            document.querySelector("[data-product-main]")?.classList.add("is-one-time");
                            const t = document.querySelector("[data-product-money]"),
                                n = t?.innerText;
                            this.updatePriceValue(e, n), this.updatePriceValue(i, n);
                        }
                    }
                    updatePriceValue(t, e) {
                        setTimeout(() => {
                            t && (t.innerText = e || "");
                        }, 200);
                    }
                    updateAddToCart(t) {
                        if (!this.btnAdd) return;
                        const e = (0, n.cartGetQuantityOfVariant)(t.id),
                            { available: i, inventory_policy: s, inventory_management: a, inventory_quantity: r } = t;
                        i ? ("continue" != s && null != a && (r || 0) - e <= 0 ? this.btnAllInCart() : this.btnAvailable()) : this.btnSoldOut();
                    }
                    btnAvailable() {
                        if (this.btnAdd) {
                            if (document.body.classList.contains("c-page--product"))
                                this.btnAdd.querySelectorAll(w).forEach((t) => (t.innerHTML = (0, n.t)("products.product.add_to_cart_pdp"))), P && (P.innerHTML = (0, n.t)("products.product.add_to_cart_pdp"));
                            else {
                                if (!this.btnAddDesktop || !this.btnAddMobile) return;
                                this.btnAddDesktop.querySelectorAll(w).forEach((t) => (t.innerHTML = (0, n.t)("products.product.quick_add"))),
                                P && (P.innerHTML = (0, n.t)("products.product.quick_add")),
                                    this.btnAddMobile.querySelectorAll(w).forEach((t) => (t.innerHTML = (0, n.t)("products.product.add_to_cart")));
                            }
                            this.btnAdd.classList.remove(a),
                                this.btnAdd.removeAttribute(L),
                                this.btnAdd.removeAttribute("disabled"),
                                (this.btnAdd.disabled = !1),
                            M && (M.classList.remove(a), M.removeAttribute(L), M.removeAttribute("disabled"), (M.disabled = !1));
                        }
                    }
                    btnAllInCart() {
                        this.btnAdd &&
                        (this.btnAdd.classList.add(a),
                            this.btnAdd.setAttribute(L, L),
                            this.btnAdd.setAttribute("disabled", ""),
                            this.btnAdd.querySelectorAll(w).forEach((t) => (t.innerHTML = (0, n.t)("products.product.all_in_cart"))),
                        P && (P.innerHTML = (0, n.t)("products.product.all_in_cart")),
                        M && (M.classList.add(a), M.setAttribute(L, L), M.setAttribute("disabled", "")));
                    }
                    btnSoldOut() {
                        this.btnAdd &&
                        (this.btnAdd.classList.add(a),
                            this.btnAdd.setAttribute(L, L),
                            this.btnAdd.setAttribute("disabled", ""),
                            this.btnAdd.querySelectorAll(w).forEach((t) => {
                                t.innerHTML = (0, n.t)("products.product.sold_out");
                            }),
                        P && (P.innerHTML = (0, n.t)("products.product.sold_out")),
                        M && (M.classList.add(a), M.setAttribute(L, L), M.setAttribute("disabled", "")));
                    }
                    btnAdded() {
                        this.btnAdd &&
                        (this.btnAdd.querySelectorAll(w).forEach((t) => (t.innerHTML = (0, n.t)("products.product.added_to_cart"))),
                        P && (P.innerHTML = (0, n.t)("products.product.added_to_cart")),
                            this.btnAdd.classList.remove(a),
                            this.btnAdd.removeAttribute(L),
                            this.btnAdd.removeAttribute("disabled"),
                            (this.btnAdd.disabled = !1),
                        M && (M.classList.remove(a), M.removeAttribute(L), M.removeAttribute("disabled"), (M.disabled = !1)));
                    }
                    btnPending() {
                        this.btnAdd &&
                        (this.btnAdd.querySelectorAll(w).forEach((t) => (t.innerHTML = (0, n.t)("products.product.cart_pending"))),
                        P && (P.innerHTML = (0, n.t)("products.product.cart_pending")),
                            (this.btnAdd.disabled = !0),
                        M && (M.disabled = !0));
                    }
                    initSwatches() {
                        this.swatches = new S(this.container, !0);
                    }
                    attachEvents() {
                        this.initSwatches(),
                            this.container.addEventListener(h, () => this.onVariantChange()),
                            setTimeout(() => {
                                this.updateStickyPriceBasedOnSubscription(), this.updateRechargeCustomPercentage();
                            }, 2e3),
                        M &&
                        M.addEventListener("click", (t) => {
                            t.preventDefault(), t.stopPropagation();
                            let e = document.querySelector("[data-product-main] [data-product-form-add]");
                            e && e.click();
                        });
                    }
                    updateRechargeCustomPercentage() {
                        const t = document.querySelector("[data-product-main]"),
                            e = t?.querySelectorAll(".rc-radio__subscription"),
                            i = document?.querySelectorAll(".rc-radio__price");
                        (this.customRetailPercentage = Number(t?.getAttribute("data-custom-percentage"))),
                            (this.customRetailWording = String(t?.getAttribute("data-custom-wording"))),
                            e?.forEach((t) => {
                                this.customRetailPercentage && this.customRetailPercentage > 0 && (t.innerHTML = `${(0, n.t)("products.product.custom_subscribe_save")} ${this.customRetailPercentage}% ${this.customRetailWording}`);
                            }),
                        this.customRetailPercentage &&
                        this.customRetailPercentage > 0 &&
                        i?.forEach((t) => {
                            this.ogPrice = Number(String(t.textContent).replace("$", "").replace(".", ""));
                            const e = 1 - this.customRetailPercentage / 100;
                            let i = this.ogPrice / e / 100;
                            i = Math.round(100 * i) / 100;
                            const s = 100 * Math.ceil(i);
                            t.innerHTML = `\n          <span class="is-price">${(0, n.printMoney)(Number(this.ogPrice))}</span>\n          <span class="is-compare">${(0, n.printMoney)(Number(s))}</span>\n        `;
                        });
                    }
                    reinitialiseSwatches(t) {
                        this.detatchEvents(), this.swatches?.loadData(t), this.attachEvents(), this.onVariantChange();
                    }
                    detatchEvents() {
                        this.swatches?.dispose();
                    }
                }
                const k = "[data-pseudo-variant-wrapper]",
                    C = "[data-swatch-dropdown]",
                    V = ".o-variant-selector__dropdown",
                    H = "[data-selected-pseudo-variant]",
                    x = [];
                class I {
                    formElement = null;
                    form = null;
                    toggleFormBtns = null;
                    pseudoVariantBtns = null;
                    pseudoVariantLabel = null;
                    pseudoVariantSwatch = null;
                    mainImage = null;
                    mobileMainImage = null;
                    mobilePopup = null;
                    mobilePopupToggles = null;
                    addButton = null;
                    subscribeBtn = null;
                    oneTimeBtn = null;
                    sellingPlans = null;
                    customRetailPercentage = 0;
                    customRetailWording = null;
                    constructor(t) {
                        (this.container = t),
                            (this.formElement = t.querySelector("[data-product-form]")),
                            (this.toggleFormBtns = t.querySelectorAll("[data-product-form-toggle]")),
                            (this.pseudoVariantBtns = t.querySelectorAll("[data-pseudo-variant]")),
                            (this.pseudoVariantLabel = t.querySelectorAll("[data-pseudo-label]")),
                            (this.pseudoVariantSwatch = t.querySelector("[data-swatch-label]")),
                            (this.mainImage = t.querySelector(".o-product-thumbnail__image-container")),
                            (this.mobileMainImage = t.querySelector(".o-product-thumbnail__mobile-popup-image-container .o-responsive-image-container")),
                            (this.mobilePopup = t.querySelector("[data-mobile-popup-contianer]")),
                            (this.mobilePopupToggles = t.querySelectorAll("[data-mobile-popup-toggle]")),
                            (this.addButton = t.querySelector("[data-product-quick-add]")),
                            (this.subscribeBtn = t.querySelector("[data-subscribe]")),
                            (this.oneTimeBtn = t.querySelector("[data-one-time]")),
                            (this.sellingPlans = t.querySelector("[data-selling-plans]")),
                            (this.customRetailPercentage = Number(t.getAttribute("data-custom-percentage"))),
                        this.sellingPlans && (this.sellingPlanId = this.sellingPlans.value),
                            this.attachEvents();
                    }
                    updateVariantId(t) {}
                    attachEvents() {
                        this.formElement && ((this.form = new T(this.formElement)), this.formElement?.querySelector(C)?.addEventListener("change", this.updateVariantId)),
                            this.mobilePopupToggles?.forEach((t) => {
                                t.addEventListener("click", (t) => this.toggleMobileForme(t));
                            }),
                            this.container?.addEventListener("mouseenter", () => {
                                this.container.classList.add(c);
                            }),
                            this.container?.addEventListener("mouseleave", () => {
                                this.container.classList.remove(c);
                            }),
                        this.pseudoVariantBtns &&
                        Array.from(this.pseudoVariantBtns).forEach((t) => {
                            t.addEventListener("click", (e) => this.handlePseudoVariantClick(e, t));
                        }),
                            this.swatchDropdown(),
                            setTimeout(() => {
                                this.initBadgesCarousel();
                            }, 1e3),
                            this.subscribeBtn?.addEventListener("click", (t) => {
                                this.toggleSubscribe(t);
                            }),
                            this.oneTimeBtn?.addEventListener("click", (t) => {
                                this.toggleOneTime(t);
                            }),
                            this.subscribeBtn ? (this.hasSellingPlan = !0) : (this.hasSellingPlan = !1),
                        this.sellingPlans &&
                        this.sellingPlans.addEventListener("change", () => {
                            this.setSubscriptionPlan();
                        }),
                            this.container.addEventListener("updatePricing", (t) => {
                                this.updatePricing(t);
                            });
                    }
                    toggleMobileForme(t) {
                        t.preventDefault(), this.mobilePopup?.classList.toggle("is-open");
                    }
                    updatePricing(t) {
                        const e = t.detail.variant;
                        let i = "",
                            s = 0,
                            a = 0,
                            r = e.compare_at_price,
                            o = e.price;
                        e.custom_retail_compare && (r = e.custom_retail_compare),
                            e.custom_retail_percentage
                                ? ((this.customRetailPercentage = e.custom_retail_percentage), this.container.classList.add("has-custom-percentage"))
                                : ((this.customRetailPercentage = 0), this.container.classList.remove("has-custom-percentage")),
                        e.custom_retail_wording && (this.customRetailWording = e.custom_retail_wording),
                            e.selling_plan_allocations.forEach((t, e) => {
                                if (0 === e) {
                                    (i += `<option value="${t.selling_plan_id}" selected></option>`), (s = t.price), (a = t.compare_at_price);
                                    const e = this.container?.querySelector("[data-selling-plan-container]");
                                    if (this.hasSellingPlan) {
                                        if (!e) return;
                                        e.innerHTML = `<input name="selling_plan" type="hidden" value="${t.selling_plan_id}">`;
                                    } else {
                                        if (!e) return;
                                        e.innerHTML = "";
                                    }
                                }
                            });
                        const l = this.container.querySelector(".o-variant-selector__dropdown");
                        if (l)
                            for (const t of l.options)
                                if (Number(t.value) === Number(e.id)) {
                                    l.value = t.value;
                                    break;
                                }
                        let c = this.container?.querySelector('input[name="product-id"]');
                        c && (c.value = e.id), this.sellingPlans && (this.sellingPlans.innerHTML = i);
                        const d = this.container?.querySelectorAll(".o-product-thumbnail__pricing.is-subscribe"),
                            u = this.container?.querySelectorAll(".o-product-thumbnail__price-wrapper.is-subscribe"),
                            h = this.container?.querySelectorAll("[data-subscription-price]"),
                            p = this.container?.querySelectorAll("[data-subscription-price-adjusted]"),
                            m = this.container?.querySelectorAll("[data-subscription-percent]"),
                            b = this.container.querySelector(".o-product-thumbnail__inner"),
                            g = this.container?.querySelector(".o-product-thumbnail__badge.is-custom-percentage");


                        document.querySelectorAll('.product-grid-badge .product-grid-badge__inner').forEach(el => {
                            el.style.display = 'none';
                        });

                        // Select the specific element with the matching data-variant-id
                        let variantBadge = document.querySelector(`.product-grid-badge__inner[data-variant-id="${e.id}"]`);
                        if (variantBadge) {
                            variantBadge.style.display = '';
                        }

                        let v = ((a - s) / a) * 100,
                            y = "";
                        (y = this.customRetailPercentage && this.customRetailPercentage > 0 ? `` : ""),
                            g
                                ? "" != y || (b && b.querySelector(".o-product-thumbnail__badge.is-custom-percentage")?.remove())
                                : "" != y
                                    ? b && b.insertAdjacentHTML("afterbegin", y)
                                    : b && b.querySelector(".o-product-thumbnail__badge.is-custom-percentage")?.remove(),
                        m &&
                        m.forEach((t) => {
                            this.customRetailPercentage && this.customRetailPercentage > 0 ? (t.innerHTML = `${this.customRetailPercentage}% ${this.customRetailWording}`) : (t.innerHTML = `${v}%`);
                        }),
                        h &&
                        h.forEach((t) => {
                            t.innerHTML = `${(0, n.printMoney)(Number(a))}`;
                        }),
                        p &&
                        p.forEach((t) => {
                            t.innerHTML = `\n          ${(0, n.printMoney)(Number(s))}\n        `;
                        }),
                        d &&
                        d.forEach((t) => {
                            const e = t.querySelector(".o-pricing__price"),
                                i = t.querySelector(".o-pricing__compare");
                            e && (e.innerHTML = `${(0, n.printMoney)(Number(o))}`), i && (i.innerHTML = r > 0 ? `${(0, n.printMoney)(Number(r))}` : "");
                        }),
                        u &&
                        u.forEach((t) => {
                            const e = t.querySelector(".o-pricing__compare");
                            e && (e.innerHTML = r > 0 ? `${(0, n.printMoney)(Number(r))}` : "");
                        });
                        let f = "";
                        this.mainImage &&
                        this.mobileMainImage &&
                        e.featured_image &&
                        ((f = e.featured_image?.src ? e.featured_image.src : e.featured_image ? e.featured_image : ""), this.updateInitialImage(this.mainImage, f), this.updateInitialImage(this.mobileMainImage, f)),
                            this.checkButtonState(e),
                            this.setSubscriptionPlan(),
                            0 === e.selling_plan_allocations.length
                                ? (this.oneTimeBtn?.click(), this.oneTimeBtn?.parentElement?.classList.add("is-hidden"), this.subscribeBtn?.setAttribute("disabled", "disabled"), this.container.classList.remove("has-selling-plan"))
                                : (this.subscribeBtn?.removeAttribute("disabled"), this.oneTimeBtn?.parentElement?.classList.remove("is-hidden"), this.subscribeBtn?.click(), this.container.classList.add("has-selling-plan"));
                    }
                    updateInitialImage(t, e) {
                        if (!t) return;
                        let i = t.querySelector("picture");
                        if (!i) return;
                        const n = `\n      <picture>\n        <img src="${String(e.replace(".jpg", "_x800.jpg"))}" class="o-responsive-image">\n      </picture>\n    `,
                            s = document.createElement("template");
                        s.innerHTML = n.trim();
                        const a = s.content.firstChild,
                            r = a.querySelector("img");
                        r &&
                        ((a.style.opacity = "0"),
                            i.after(a),
                            i.offsetWidth,
                            (r.onload = () => {
                                (a.style.transition = "opacity 0.5s"), (a.style.opacity = "1"), i?.remove(), (i = a);
                            }));
                    }
                    setSubscriptionPlan() {
                        this.sellingPlanId = String(this.sellingPlans?.value);
                        const t = this.container?.querySelector("[data-selling-plan-container]"),
                            e = `\n      <input name="selling_plan" type="hidden" value="${this.sellingPlanId}">\n    `;
                        if (this.hasSellingPlan) {
                            if (!t) return;
                            t.innerHTML = e;
                        } else {
                            if (!t) return;
                            t.innerHTML = "";
                        }
                    }
                    toggleSubscribe(t) {
                        t.preventDefault();
                        t.currentTarget.classList.add("is-active"), this.oneTimeBtn?.classList.remove("is-active"), (this.hasSellingPlan = !0), this.container.classList.add("has-selling-plan"), this.setSubscriptionPlan();
                    }
                    toggleOneTime(t) {
                        t.preventDefault();
                        t.currentTarget.classList.add("is-active"), this.subscribeBtn?.classList.remove("is-active"), (this.hasSellingPlan = !1), this.container.classList.remove("has-selling-plan"), this.setSubscriptionPlan();
                    }
                    swatchDropdown() {
                        let t = this.formElement?.querySelector(C),
                            e = this.formElement?.querySelector(H);
                        const i = this.formElement?.querySelector(V);
                        t &&
                        t.addEventListener("change", (t) => {
                            t.preventDefault();
                            const n = t.currentTarget;
                            let s = n.options[n.selectedIndex].getAttribute("data-id");
                            e && s && (e.value = s), i && s && (i.value = s);
                        });
                    }
                    handlePseudoVariantClick(t, e) {
                        t.preventDefault();
                        let i = "",
                            n = "",
                            a = "";
                        if (!this.pseudoVariantBtns || void 0 === e) return;
                        const r = this.formElement?.querySelector(H),
                            o = this.formElement?.querySelector("[data-variant-selected-id]"),
                            l = e?.getAttribute("data-pseudo-label"),
                            c = e?.getAttribute("data-product-label"),
                            d = e?.getAttribute("data-pseudo-link"),
                            u = e?.querySelector("[data-pseudo-variants]"),
                            h = this.container.querySelectorAll("[data-thumbnail-title]"),
                            p = this.container.querySelectorAll("[data-thumbnail-link]"),
                            m = e.getAttribute("data-pseudo-variant"),
                            b = this.formElement?.querySelector(C),
                            g = this.formElement?.querySelector(V),
                            v = JSON.parse(u?.innerHTML),
                            y = e.closest(k);
                        Array.from(this.pseudoVariantBtns).forEach((t) => {
                            t.closest(k)?.classList.remove(s);
                        });
                        let f = "",
                            _ = "";
                        if (u) {
                            if (!v) return;
                            v.variants.forEach((t) => {
                                t.custom_retail_percentage
                                    ? ((this.customRetailPercentage = Number(t.custom_retail_percentage)), this.container.classList.add("has-custom-percentage"))
                                    : ((this.customRetailPercentage = 0), this.container.classList.remove("has-custom-percentage")),
                                t.custom_retail_wording && (this.customRetailWording = t.custom_retail_wording),
                                    (_ = t.swatch_image?.src ? t.swatch_image.src : t.swatch_image ? t.swatch_image : ""),
                                    (i += `<option value="${t.handle}" data-id="${t.id}">${t.title}</option>`),
                                    (n += `<option value="${t.id}">${t.title}</option>`),
                                    (a += `\n          <div class="o-swatches__swatch-button-wrap is-image ${t.handle}" data-thumbs-carousel-item="">\n            <button title="${
                                        t.title
                                    }" type="button" class="o-swatches__swatch-button s-swatch--${t.handle} is-selected"\n              data-swatch-object data-value="${t.handle}" data-swatch-position="1" data-title="${
                                        t.title
                                    }">\n              <img class="o-swatches__image o-swatches__image--first" src="${String(_).replace(
                                        ".jpg",
                                        "_100x.jpg"
                                    )}">\n              <img class="o-swatches__image o-swatches__image--second" src="${String(_).replace(".jpg", "_100x.jpg")}">\n            </button>\n          </div>\n        `),
                                    t.selling_plan_allocations.forEach((t, e) => {
                                        if (0 === e) {
                                            f += `<option value="${t.selling_plan_id}" selected></option>`;
                                            const e = this.container?.querySelector("[data-selling-plan-container]");
                                            if (this.hasSellingPlan) {
                                                if (!e) return;
                                                e.innerHTML = `<input name="selling_plan" type="hidden" value="${t.selling_plan_id}">`;
                                            } else {
                                                if (!e) return;
                                                e.innerHTML = "";
                                            }
                                        }
                                    });
                            });
                        }
                        this.sellingPlans && (this.sellingPlans.innerHTML = f),
                        "" != i && b && ((b.innerHTML = i), (g.innerHTML = n)),
                        "" != n && g && (g.innerHTML = n),
                        this.pseudoVariantSwatch && (this.pseudoVariantSwatch.innerHTML = l),
                        h &&
                        h.forEach((t) => {
                            t.innerHTML = c;
                        }),
                        p &&
                        null != d &&
                        p.forEach((t) => {
                            t.setAttribute("href", d);
                        }),
                        r && m && ((r.value = m), o && (o.value = m)),
                            y?.classList.add(s);
                        let S = this.container?.querySelector('input[name="product-id"]');
                        S && (S.value = v.id), this.checkButtonState(v);
                        const L = this.container?.querySelectorAll(".o-swatches__wrapper:not(.is-pseudo)");
                        L.forEach((t) => {
                            1 == v.variants.length
                                ? t.classList.add("is-hidden")
                                : (t.classList.remove("is-hidden"),
                                t.classList.contains("is-select") &&
                                (t.innerHTML = `\n          <div class="o-swatches o-product-thumbnail__swatches" data-swatches>\n            <div class="o-variant-selector o-swatches__variant-selector no-js" data-variant-selector>\n              <select name="id" class="o-input o-variant-selector__dropdown">\n                ${n}\n              </select>\n            </div>\n            <div class="o-swatches__swatches has-js">\n              <div class="o-swatches__inner o-swatches__inner-select">\n                <div class="o-swatches__swatch is-select" data-swatch data-swatch-position="1">\n                  <select class="o-swatches__select o-select" name="option-0" data-swatch-dropdown>\n                    ${i}\n                  </select>\n                </div>\n              </div>\n            </div>\n          </div>\n          `),
                                t.classList.contains("is-color") &&
                                (t.innerHTML = `\n          <h6 class="o-swatches__title" data-swatch-title="">Spool and Dispenser</h6>\n            <div class="o-swatches o-product-thumbnail__swatches" data-swatches>\n              <div class="o-variant-selector o-swatches__variant-selector no-js" data-variant-selector>\n                <select name="id" class="o-input o-variant-selector__dropdown">\n                  ${n}\n                </select>\n              </div>\n              <div class="o-swatches__swatches has-js">\n                <div class="o-swatches__inner o-swatches__inner-color">\n                  <div class="o-swatches__swatch is-select is-centered" data-swatch="" data-swatch-position="1">\n                    <div class="o-swatches__swatch-options is-color">\n                      ${a}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          `));
                        }),
                            this.form?.reinitialiseSwatches(v);
                    }
                    checkButtonState(t) {
                        const e = this.addButton?.querySelectorAll("[data-label-element]");
                        !0 === t.available
                            ? (this.addButton?.classList.add("is-label-animated"),
                                this.addButton?.classList.remove("is-disabled"),
                                this.addButton?.removeAttribute("disabled"),
                                e?.forEach((t) => {
                                    t.innerHTML = "Quick add";
                                }))
                            : (this.addButton?.classList.remove("is-label-animated"),
                                this.addButton?.classList.add("is-disabled"),
                                this.addButton?.setAttribute("disabled", "disabled"),
                                e?.forEach((t) => {
                                    t.innerHTML = "Out of stock";
                                }));
                    }
                    initBadgesCarousel = () => {
                        const t = "data-resize";
                        this.container.querySelectorAll("[data-thumbs-carousel-container]").forEach((e) => {
                            if (e.classList.contains(r)) return;
                            e.classList.add(r);
                            const i = e.querySelector("[data-thumbs-carousel]"),
                                n = e.querySelector("[data-thumbs-carousel-prev]"),
                                s = e.querySelector("[data-thumbs-carousel-next]"),
                                a = e.querySelectorAll("[data-thumbs-carousel-item]"),
                                o = Number(e.getAttribute("data-gap")),
                                c = e.hasAttribute("data-no-touch"),
                                h = e.querySelector("[data-thumbs-carousel-progress-bar]");
                            if (0 === a.length) return void e.classList.remove(l);
                            e.classList.add(l);
                            let p,
                                m,
                                b,
                                g = 0,
                                v = 0,
                                y = 0,
                                f = 0,
                                _ = 0,
                                S = 0,
                                L = !1;
                            e.classList.add(r);
                            const A = () => {
                                    if (e.hasAttribute("data-thumbs-carousel-disabled-mobile") && window.outerWidth < 750) return;
                                    if (!i) return;
                                    (f = e.clientWidth), (_ = Number(i.clientWidth));
                                    const t = E(0);
                                    S = window.outerWidth >= 750 ? 2 * o : o;
                                    const n = Array.from(a).reduce((e, i) => e + t + S, 0),
                                        s = 3 * t + 2 * S;
                                    (y = Math.max(0, Math.ceil((n - s) / (t + S)))), s < f && (y = Math.max(y, v)), (v = Math.min(y, Math.max(0, v)));
                                    const r = (e) => e * (t + S);
                                    if (_ < f) return e.classList.add(d), e.classList.add(u), void (i.style.transform = "translateX(0)");
                                    r(v) > n - f ? ((L = !0), (m = -(n - f))) : (m = -r(v)), (i.style.transform = `translateX(${m}px)`), w(), q();
                                },
                                q = () => {
                                    if (e.hasAttribute(t) && "true" === e.getAttribute(t)) {
                                        const t = a[v].children[0];
                                        t && i && (i.style.height = `${t.offsetHeight}px`);
                                    }
                                },
                                E = (t) => {
                                    const e = a[t],
                                        i = getComputedStyle(e),
                                        n = parseInt(i.marginLeft || "0"),
                                        s = parseInt(i.marginRight || "0"),
                                        r = parseInt(i.paddingLeft || "0"),
                                        o = parseInt(i.paddingRight || "0");
                                    return e.offsetWidth + n + s + r + o;
                                },
                                w = () => {
                                    (b = (v / y) * 100),
                                    L && (b = 100),
                                    h &&
                                    ((h.style.width = `${b}%`),
                                        b > 0
                                            ? (h.parentElement?.classList.add("is-visible"), h.parentElement?.parentElement?.classList.add("has-progress"))
                                            : (h.parentElement?.classList.remove("is-visible"), h.parentElement?.parentElement?.classList.remove("has-progress"))),
                                        e.classList.toggle(d, 0 === v),
                                        e.classList.toggle(u, L);
                                };
                            n?.addEventListener("click", (t) => {
                                t.preventDefault(), v > 0 && ((L = !1), (v -= 3), (v = Math.max(0, v)), A());
                            }),
                                s?.addEventListener("click", (t) => {
                                    t.preventDefault(), v < y && ((v += 3), (v = Math.min(y, v)), A());
                                }),
                                window.addEventListener("resize", () => {
                                    clearTimeout(p),
                                        (p = setTimeout(() => {
                                            A();
                                        }, 500));
                                }),
                                e.addEventListener(
                                    "touchstart",
                                    (t) => {
                                        c || (g = t.touches[0].clientX);
                                    },
                                    { passive: !0 }
                                ),
                                e.addEventListener(
                                    "touchmove",
                                    (t) => {
                                        if (c) return;
                                        const e = t.touches[0].clientX,
                                            i = e - g;
                                        Math.abs(i) > 70 && (i > 0 && v > 0 ? ((L = !1), (v -= 3), (v = Math.max(0, v))) : i < 0 && v < y && !L && ((v += 3), (v = Math.min(y, v))), A(), (g = e));
                                    },
                                    { passive: !0 }
                                ),
                                A();
                        });
                    };
                    detatchEvents() {
                        this.form && this.form.detatchEvents();
                    }
                }
                const $ = () => {
                    [...x].forEach((t) => {
                        t.container || t.detatchEvents();
                    }),
                        document.querySelectorAll("[data-product-thumbnail]").forEach((t) => {
                            t.classList.contains(o) || (t.classList.add(o), new I(t));
                        });
                };
                $();
                const N = "data-section-initialized";
                class B {
                    static registrations = {};
                    static register(t, e) {
                        const i = [];
                        return (
                            document.querySelectorAll(t).forEach((n) => {
                                if (B.isRegistered(n)) return;
                                const s = new e(n, t);
                                i.push(s), s.queryChildren(n), s.init(), s.attachEvents(n);
                            }),
                                (this.registrations[t] = e),
                                i
                        );
                    }
                    static recheck(t) {
                        const e = this.registrations[t];
                        return e ? B.register(t, e) : [];
                    }
                    static isRegistered(t) {
                        return t.hasAttribute(N);
                    }
                    constructor(t, e) {
                        if (((this.container = t), (this.selector = e), this.container.setAttribute(N, "true"), (this.shopifyContainer = this.container.parentElement), this.shopifyContainer && this.shopifyContainer.id))
                            try {
                                this.id = this.shopifyContainer.id.replace(/shopify-section-/, "");
                            } catch (t) {
                                console.warn(t);
                            }
                        this.innerHtmlObserver = null;
                    }
                    replaceContainer(t) {
                        this.container.removeAttribute(N),
                            this.detatchEvents(this.container),
                            (this.container.innerHTML = t.innerHTML),
                            this.container.setAttribute(N, "true"),
                            this.queryChildren(this.container),
                            this.init(),
                            this.attachEvents(this.container);
                    }
                    init() {}
                    onInnerHtmlMutationObserved = (t, e) => {
                        if (!t.length) return;
                        if (!this.shopifyContainer) return;
                        const [i] = t,
                            n = [];
                        i.removedNodes.forEach((t) => n.push(t));
                        -1 !== n.findIndex((t) => t === this.shopifyContainer) && (console.log("Section", this.id, "reloaded."), this.dispose(), B.recheck(this.selector));
                    };
                    dispose() {
                        this.container.removeAttribute(N), this.detatchEvents(this.container), this.innerHtmlObserver && this.innerHtmlObserver.disconnect();
                    }
                }
                B.register(
                    "[data-collection-template]",
                    class extends B {
                        queryChildren(t) {}
                        attachEvents() {
                            $();
                        }
                        detatchEvents() {}
                    }
                );
            },
        },
        i = {};
    function n(t) {
        var s = i[t];
        if (void 0 !== s) return s.exports;
        var a = (i[t] = { exports: {} });
        return e[t].call(a.exports, a, a.exports, n), a.exports;
    }
    (n.m = e),
        (t = []),
        (n.O = function (e, i, s, a) {
            if (!i) {
                var r = 1 / 0;
                for (d = 0; d < t.length; d++) {
                    (i = t[d][0]), (s = t[d][1]), (a = t[d][2]);
                    for (var o = !0, l = 0; l < i.length; l++)
                        (!1 & a || r >= a) &&
                        Object.keys(n.O).every(function (t) {
                            return n.O[t](i[l]);
                        })
                            ? i.splice(l--, 1)
                            : ((o = !1), a < r && (r = a));
                    if (o) {
                        t.splice(d--, 1);
                        var c = s();
                        void 0 !== c && (e = c);
                    }
                }
                return e;
            }
            a = a || 0;
            for (var d = t.length; d > 0 && t[d - 1][2] > a; d--) t[d] = t[d - 1];
            t[d] = [i, s, a];
        }),
        (n.g = (function () {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (t) {
                if ("object" == typeof window) return window;
            }
        })()),
        (n.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (n.j = 2318),
        (function () {
            var t = { 2318: 0 };
            n.O.j = function (e) {
                return 0 === t[e];
            };
            var e = function (e, i) {
                    var s,
                        a,
                        r = i[0],
                        o = i[1],
                        l = i[2],
                        c = 0;
                    if (
                        r.some(function (e) {
                            return 0 !== t[e];
                        })
                    ) {
                        for (s in o) n.o(o, s) && (n.m[s] = o[s]);
                        if (l) var d = l(n);
                    }
                    for (e && e(i); c < r.length; c++) (a = r[c]), n.o(t, a) && t[a] && t[a][0](), (t[a] = 0);
                    return n.O(d);
                },
                i = (self.webpackChunkreflect_boilerplate = self.webpackChunkreflect_boilerplate || []);
            i.forEach(e.bind(null, 0)), (i.push = e.bind(null, i.push.bind(i)));
        })(),
        n.O(void 0, [4121], function () {
            return n(7660);
        });
    var s = n.O(void 0, [4121], function () {
        return n(5660);
    });
    s = n.O(s);
})();
